import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import { useDispatch, useSelector } from "react-redux";
import { getClients } from "actions/clients";

const Clients = ({ navigation }) => {
  const location = useLocation();
  const clients = useSelector((state) => state.clients.clients);
  const dispatch = useDispatch();
  const [body, setBody] = useState([]);
  const [head, setHead] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!clients) {
      dispatch(getClients());
    } else {
      const keys = ["id", "name"];
      setHead(keys);
      setBody(
        clients.map((client) => {
          const values = [client.id, client.name];
          return values;
        })
      );
    }
  }, [clients, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const editClient = (row) => {
    const client = {};
    head.forEach((key, index) => {
      client[key] = row[index];
    });
    navigate(`/admin/client/${client.id}`);
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="w-full px-4">
              <CardFullTable
                title="Clients"
                titlebutton={
                  <i
                    onClick={() => navigate("/admin/client")}
                    className="fa fa-plus text-sm cursor-pointer"
                  />
                }
                head={head}
                body={body}
                color="white"
                onRowClick={(row) => editClient(row)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Clients;
